import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack } from "@mui/material";
import MaterialInput from "../../../../components/common/UI/MaterialInput"; // Adjust the path as needed

const PermissionModal = ({
  isModalOpen,
  isEditMode,
  currentPermission,
  setCurrentPermission,
  handleFormSubmit,
  handleCloseModal,
}) => {
  // A helper function to create a simplified onChange handler for MaterialInput
  const handleInputChange = (e, name) => {
    setCurrentPermission({ ...currentPermission, [name]: e.target.value });
  };

  return (
    <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm" aria-labelledby="modalTitle">
      <DialogTitle id="modalTitle">
        {isEditMode ? `Edit Permission: ${currentPermission.name}` : "Create New Permission"}
      </DialogTitle>
      <DialogContent dividers>
        <Stack component="form" spacing={2} onSubmit={handleFormSubmit}>
          <MaterialInput
            type="text"
            name="name"
            placeholder="Name"
            value={currentPermission.name}
            onChange={(e) => handleInputChange(e, "name")}
            readOnly={isEditMode} // This prop might need to be handled inside MaterialInput
            disabled={isEditMode} // Use disabled instead of readOnly for consistent styling
          />
          <MaterialInput
            type="textarea" // Use "textarea" to enable multiline input
            name="description"
            placeholder="Description"
            value={currentPermission.description}
            onChange={(e) => handleInputChange(e, "description")}
            rows={3} // Pass rows prop to the MaterialInput component
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModal} style={{ color: "#ED141F" }}>
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={handleFormSubmit}
          style={{ background: "#ED141F" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PermissionModal;
